import(/* webpackMode: "eager" */ "/home/ignacio/Documents/REPOSITORY/WEBSITES/Apex-Experience/apex-next/app/global-error.tsx");
